module.exports = __webpack_public_path__ + "static/media/logo-footer.f77b54b7.png";